import React from 'react';
import styled from 'styled-components';
import ControlQuadrant from "./ControlQuadrant";
import {useBoundStore} from "../../stores/useBoundStore";
import PropTypes from "prop-types";

const Holder = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 2px;
  button {
    svg {
      overflow: visible;
      path, ellipse, circle, rect, polygon {
        stroke: transparent;
        stroke-width: 1px;
        vector-effect: non-scaling-stroke;
      }
    }
    &.active {
      svg {
        path, ellipse, circle, rect, polygon {
          stroke: var(--color-1);
        }
      }
    }
  }
`;

function Control(props) {
  const quad1Settings = useBoundStore((state) => state.quad1)
  const quad2Settings = useBoundStore((state) => state.quad2)
  const quad3Settings = useBoundStore((state) => state.quad3)
  const quad4Settings = useBoundStore((state) => state.quad4)

  return (
    <Holder className="control">
      <button onClick={() => props.clickHandler(0)} className={props.activeQuad === 0 ? 'active': ''}>
        <ControlQuadrant settings={quad1Settings} />
      </button>
      <button onClick={() => props.clickHandler(1)} className={props.activeQuad === 1 ? 'active': ''}>
        <ControlQuadrant settings={quad2Settings} />
      </button>
      <button onClick={() => props.clickHandler(2)} className={props.activeQuad === 2 ? 'active': ''}>
        <ControlQuadrant settings={quad3Settings} />
      </button>
      <button onClick={() => props.clickHandler(3)} className={props.activeQuad === 3 ? 'active': ''}>
        <ControlQuadrant settings={quad4Settings} />
      </button>
    </Holder>
  )
}

Control.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  activeQuad: PropTypes.number.isRequired,
};

export default Control;